import AxiosClient from "../../../services/axios.services";

class TechnicalKnowledgeAcquiredServices {
  getTechnicalKnowledgeAcquired = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_conocimiento_tecnico_adquirido/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getTechnicalKnowledgeAcquiredById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_conocimiento_tecnico_adquirido/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });

  saveTechnicalKnowledgeAcquired = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_conocimiento_tecnico_adquirido/", data, {
      headers: { "Content-Type": "application/json" },
    });

  editTechnicalKnowledgeAcquired = (id, data) =>
    AxiosClient.put(`/api/app/descriptor_perfil_conocimiento_tecnico_adquirido/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  deleteTechnicalKnowledgeAcquired = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_conocimiento_tecnico_adquirido/${id}`, {
      headers: { "Content-Type": "aplication/json" },
    });
}

export default new TechnicalKnowledgeAcquiredServices();
